import { NotifyHelper } from "../../../helpers/toast";
import { IChotDuLieuKetQua, IChuyenLopKetQua } from "../../../model/respone/phan-lop-chuyen-nganh/IPhanLopChuyenNganh";
import { ePhanLopChuyenNganhActionsObj } from "../../action-types/phan-lop-chuyen-nganh/IPhanLopChuyenNganhActions";
import { generateActionForKey, generateActions } from "../generateActions";

const PREFIX = "PHAN_LOP_CHUYEN_NGANH";

/** Đếm số dòng thành công / tổng để hiện toast gọn cho các thao tác ghi theo từng sinh viên. */
const toastKetQua = (label: string) => (data: IChuyenLopKetQua[]) => {
  const list = data ?? [];
  const ok = list.filter((x) => !x.ma_loi).length;
  if (list.length === 0) NotifyHelper.Warning(`Không có sinh viên nào để ${label}`);
  else if (ok === list.length) NotifyHelper.Success(`${label} thành công ${ok}/${list.length} sinh viên`);
  else NotifyHelper.Warning(`${label}: thành công ${ok}/${list.length} sinh viên, xem chi tiết lỗi`);
};

export const phanLopChuyenNganhActions = {
  ...generateActions(ePhanLopChuyenNganhActionsObj, PREFIX),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "CHOT_SUCCESS", (data: IChotDuLieuKetQua) => {
    NotifyHelper.Success(`Chốt xong: thêm mới ${data?.so_them ?? 0}, ghi đè ${data?.so_ghi_de ?? 0}`);
  }),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "CHOT_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "SET_LOCK_SUCCESS", () => {
    NotifyHelper.Success("Cập nhật khoá thành công");
  }),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "SET_LOCK_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "DELETE_CHOTS_SUCCESS", () => {
    NotifyHelper.Success("Xoá chốt thành công");
  }),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "DELETE_CHOTS_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "SAVE_QUYET_DINH_SUCCESS", () => {
    NotifyHelper.Success("Lưu quyết định thành công");
  }),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "SAVE_QUYET_DINH_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "DELETE_QUYET_DINH_SUCCESS", () => {
    NotifyHelper.Success("Xoá quyết định thành công");
  }),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "DELETE_QUYET_DINH_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "ADD_CHI_TIETS_SUCCESS", toastKetQua("Thêm sinh viên")),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "ADD_CHI_TIETS_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "UPDATE_LOP_MOI_SUCCESS", toastKetQua("Đổi lớp chuyển")),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "UPDATE_LOP_MOI_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "CHUYEN_LOP_SUCCESS", toastKetQua("Chuyển lớp")),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "CHUYEN_LOP_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "THU_HOI_SUCCESS", toastKetQua("Thu hồi")),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "THU_HOI_ERRR", (m) => NotifyHelper.Error(m)),

  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "LOAD_TRANG_THAIS_ERRR", (m) => NotifyHelper.Error(m)),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "LOAD_QUYET_DINHS_ERRR", (m) => NotifyHelper.Error(m)),
  ...generateActionForKey(ePhanLopChuyenNganhActionsObj, PREFIX, "LOAD_CHI_TIETS_ERRR", (m) => NotifyHelper.Error(m)),
};
